// extracted by mini-css-extract-plugin
export default {"root":"global_root__NKkW6"};